module.exports = __webpack_public_path__ + "static/pipeline-code-4-3d2251e7d085abcb9af5fbcd116064af.png";